const config = {
    'consumer_key':'b0c1tzsjmG1aQUB2WOCio1k4x',
    'consumer_secret':'Y5SH6Wv1i1EQCqsZFPMrzhjsUeJbWFpKIgQLHPlzhZPs2qbhld',
    'access_token':'94147536-jQqntJRHCm2szkmSCeWoghaUSfEutDlJaPWONPmNo',
    'access_token_secret':'sy7Aaz2PrBSPCX7vz9wC2VTCxZDmG7vcDnzWN9j0cnygv'
}

module.exports = config;


// WEBPACK FOOTER //
// ./src/config/twitter-config.js